// biome-ignore assist/source/organizeImports: keep css last to avoid style precedence conflict
import classNames from 'clsx';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsMobile } from 'src/common/selectors/app';
import ProfileLogo from './ProfileLogo';
import css from './banner.module.scss';

const Banner = ({
  src,
  title,
  logoImage,
  heroHeader,
  showLogoImage,
  className,
  hasPremiumBadge,
  hasBoostBadge,
  isDiscord,
  guideItem,
}) => {
  const [imageLoadFailed, setImageLoadFailed] = useState(false);
  const isMobile = useSelector(selectIsMobile);
  // TODO: This is a temporary quick fix until we can implement this logic in Api Client. Longer term, we expect Platform to support a Partner Setting that allows profile banner images to be smaller/larger.
  const imageSrc = isMobile || !src?.includes('bannerx') ? src : src?.replace('bannerx', 'bannero');

  const onImageLoadError = () => {
    setImageLoadFailed(true);
  };

  if (imageLoadFailed) {
    return null;
  }

  return (
    <div className={css.bannerContainer}>
      <div
        data-testid="profileBannerWrapper"
        className={classNames(css.bannerWrapper, className, {
          [css.hasHeroHeader]: !!heroHeader || isDiscord,
        })}
      >
        <img
          src={imageSrc}
          alt={title}
          className={css.banner}
          data-testid="profileBanner"
          onError={onImageLoadError}
        />
      </div>
      {showLogoImage && (
        <ProfileLogo
          containerClassName={css.mobileWebProfileLogoContainer}
          imageWrapperClassName={css.mobileWebProfileLogoImageWrapper}
          key={logoImage}
          image={logoImage}
          title={title}
          hasPremiumBadge={hasPremiumBadge}
          hasBoostBadge={hasBoostBadge}
          guideItem={guideItem}
        />
      )}
    </div>
  );
};

Banner.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  logoImage: PropTypes.string,
  heroHeader: PropTypes.bool,
  showLogoImage: PropTypes.bool,
  className: PropTypes.string,
  hasPremiumBadge: PropTypes.bool,
  hasBoostBadge: PropTypes.bool,
  isDiscord: PropTypes.bool,
  guideItem: PropTypes.object,
};

export default Banner;
